import { ComplyCubeError } from "./errors/ComplyCubeError";

let crypto: typeof import("crypto") | undefined;
try {
  // tslint:disable-next-line: no-var-requires
  crypto = require("crypto");
  // tslint:disable-next-line:no-empty
} catch {}

export type Event = {
  id: string;
  type: string;
  resourceType: string;
  payload: {
    id: string;
    status: string;
    outcome?: string;
    createdAt: string;
    updatedAt: string;
  };
  createdAt: string;
};

export class EventVerifier {
  private readonly secret: string;

  constructor(secret: string) {
    this.secret = secret;
  }

  public constructEvent(requestBody: string, signature: string): Event {
    if (!crypto) {
      throw new Error("Crypto support required to verify events");
    }

    const givenSignature = Buffer.from(signature, "hex");

    const hmac = crypto.createHmac("sha256", this.secret);
    hmac.update(requestBody);
    const eventSignature = hmac.digest();

    if (!crypto.timingSafeEqual(givenSignature, eventSignature)) {
      throw new ComplyCubeError("Invalid signature for event");
    }

    const result = JSON.parse(requestBody.toString());
    return result as Event;
  }
}
